import { Component, OnInit } from '@angular/core';

import { BaseComponent } from '../shared/base.component';
import { ApplicationService } from '../services/app.service';
import { NavigationEnd, Router } from '@angular/router';
import { detectIE } from '../shared/utilities/general.utilities';

@Component({
    selector: 'app-shell-wrapper',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
})
export class ShellWrapperComponent extends BaseComponent implements OnInit {
    /** String which describes the loading state */
    public loading: string;

    constructor(private service: ApplicationService, private router: Router) {
        super();
    }

    public async ngOnInit() {
        if (detectIE() && detectIE() < 12) {
            location.href = `${location.origin}${location.pathname}assets/not-supported.html`;
            return;
        }
        if (!this.service.is_ready) {
            this.timeout('init', () => this.ngOnInit());
            return;
        }
        // Listen for loading state changes
        this.subscription(
            'system',
            this.service.listen('loading', (value) => (this.loading = value))
        );
        const resp = await fetch('/auth/authority').catch(() => ({
            json: () => new Promise<any>(() => {}),
        }));
        const authority = await resp.json();
        const pexiprtc = document.createElement('script');
        pexiprtc.type = 'text/javascript';
        pexiprtc.src =
            authority?.config?.pexiprtc ||
            this.service.setting('app.pexiprtc') ||
            this.service.setting('pexiprtc');
        document.body.appendChild(pexiprtc);
    }
}
